/* Position artwork against real content, retaining its intrinsic proportions. */
(() => {
  if (window.adkDecorLayout) { window.adkDecorLayout.mount(); return; }
  const selectors = {
    productBauble: '.shopify-section[id$="__product-template"]',
    productFooterGift: '.shopify-section[id$="__product-template"]',
    productSection: '.shopify-section[id$="__product-template"]',
    countdown: '.shopify-section[id$="__section_generic_countdown_pNU8YL"] .generic-countdown__panel',
    storeImage: '.shopify-section[id$="__base_section_k4VP3k"] img',
    charityImage: '.shopify-section[id$="__base_section_dWhYqi"] img',
    store: '.shopify-section[id$="__base_section_k4VP3k"]',
    charity: '.shopify-section[id$="__base_section_dWhYqi"]',
    faq: '.shopify-section[id$="__section_faq_4tJCTR"]',
    productBow: '.product-grid .product-title-wrapper',
    productCandy: '.product-grid .product__price'
  };
  const crops = { productDetailBauble: [633,0,0,633,640], storeCane: [1024,335,75,500,1420], charityCane: [1024,335,75,500,1420], faqMiniCane: [1024,335,75,500,1420], productCane: [1024,335,75,500,1420], faqCane: [1024,335,75,500,1420], productBauble: [532,0,0,532,640], storePinkBauble: [633,0,0,633,640], charityTopBauble: [532,0,0,532,640], faqPinkBauble: [633,0,0,633,640], storeExtraGift: [640,57,28,481,501], charityBauble: [532,46,91,467,461], storeGift: [640,0,0,640,379], productFooterGift: [640,0,0,640,389], faqBow: [640,141,30,372,575], countdown: [640,57,28,481,501], store: [532,46,91,467,461], faq: [640,58,29,479,499], storeBow: [640,141,30,372,575], storeSweet: [390,31,15,325,579], faqBerry: [248,6,8,234,239], charityBow: [640,141,30,372,575], productBow: [640,141,30,372,575], productCandy: [390,31,15,325,579] };
  let frame, observer;
  const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(layout); };
  const place = (node,x,y,w,h) => Object.assign(node.style,{left:x+'px',top:y+'px',width:w+'px',...(h == null ? {} : {height:h+'px'})});
  function layout() {
    const content = document.querySelector('body[class*="adk-2026"] #content');
    if (!content) return;
    const origin = content.getBoundingClientRect();
    const phone = innerWidth < 768;
    const tablet = innerWidth >= 768 && innerWidth < 1024;
    const boxes = {};
    for (const [key,selector] of Object.entries(selectors)) {
      const target = [...content.querySelectorAll(selector)].find(node => node.getBoundingClientRect().width > 0);
      if (!target) continue;
      const r = target.getBoundingClientRect();
      boxes[key] = {left:r.left-origin.left,right:r.right-origin.left,top:r.top-origin.top,bottom:r.bottom-origin.top,width:r.width,height:r.height};
    }
    const heading=content.querySelector('.product-grid h1');
    let lastTitleLine;
    if(heading && !phone && !tablet){
      const range=document.createRange();range.selectNodeContents(heading);
      const lines=[...range.getClientRects()].filter(r=>r.width>0);
      const line=lines[lines.length-1];
      if(line)lastTitleLine={left:line.left-origin.left,right:line.right-origin.left,top:line.top-origin.top,bottom:line.bottom-origin.top};
    }
    const artworkBoxes={};
    for (const piece of content.querySelectorAll('.adk-decoration')) {
      if(['productCane','productDetailBauble'].includes(piece.dataset.artwork)){piece.hidden=true;continue;}
      const key=piece.dataset.artwork, b=boxes[key.startsWith('store')?'store':key.startsWith('charity')?'charity':key.startsWith('faq')?'faq':key];
      piece.hidden=!b;
      if (!b) continue;
      let x,y,w;
      if (key==='countdown') {
        w=phone?86:182;
        x=b.right-w+(phone?-5:30);
        y=phone?b.top-58:b.top+(b.height-w*501/481)/2;
      } else if (key==='store') {
        w=phone?140:tablet?156:180;
        x=b.right-w+(phone?16:36);
        y=b.bottom-(phone?22:40);
      } else if (key==='faq') {
        w=phone?64:76;
        x=b.right-w+(phone?4:12);
        y=b.bottom-(phone?22:30);
      } else if (key==='productFooterGift') {
        w=phone?150:tablet?190:240;
        x=b.right-w-(phone?28:72);
        y=b.bottom-(phone?100:140);
      } else if (key==='productBauble') {
        w=phone?76:110;
        x=b.left+(phone?24:100);
        y=b.bottom-(phone?150:172);
      } else if (key==='storePinkBauble') {
        w=phone?82:116;
        const photo=boxes.storeImage;
        if(!photo){piece.hidden=true;continue;}
        x=photo.right-w+(phone?8:-2);
        y=photo.top+(phone?28:40);
      } else if (key==='charityTopBauble') {
        w=phone?64:94;
        x=b.left+(phone?12:38);
        y=b.top-(phone?58:82);
      } else if (key==='faqPinkBauble') {
        w=phone?64:88;
        x=b.right-w-(phone?10:30);
        y=b.top+(phone?12:28);
      } else if (key==='storeCane') {
        // A small edge accent breaks up the long store copy, away from the transition.
        w=phone?20:38;
        x=b.right-(phone?4:8);
        y=b.top+b.height*.78;
      } else if (key==='charityCane') {
        w=phone?30:44;
        const logo=boxes.charityImage;
        if(!logo){piece.hidden=true;continue;}
        x=Math.min(logo.right+8,b.right-w-12);
        y=logo.top+24;
      } else if (key==='faqMiniCane') {
        w=phone?22:34;
        x=b.left-(phone?16:24);
        y=b.top+b.height*.33;
      } else if (key==='faqCane') {
        w=phone?42:60;
        x=b.left+(phone?28:44);
        y=b.bottom-(phone?12:28);
      } else if (key==='faqBow') {
        w=phone?40:tablet?48:60;
        x=b.left+(phone?18:44);
        y=b.top-(phone?44:54);
      } else if (key==='storeGift') {
        w=phone?90:tablet?104:132;
        x=b.left+(phone?30:70);
        y=b.top-(phone?40:52);
      } else if (key==='storeBow') {
        w=phone?46:tablet?54:76;
        x=b.left-(phone?15:tablet?24:42);
        y=b.top+(phone?120:tablet?100:86);
      } else if (key==='storeSweet') {
        w=phone?22:tablet?32:44;
        x=phone?b.left-12:b.right-(tablet?10:18);
        y=b.top+b.height*(phone?.43:.32);
      } else if (key==='faqBerry') {
        w=phone?34:tablet?42:54;
        x=b.right-(phone?8:tablet?18:26);
        y=b.top+b.height*.52;
      } else if (key==='charityBow') {
        w=phone?38:tablet?48:64;
        x=b.right-(phone?12:tablet?18:28);
        y=b.top+b.height*(phone?.43:.46);
      } else if (key==='productBow') {
        w=phone?50:tablet?48:64;
        x=b.right-w-12;
        y=b.top-(phone?64:46);
        if(!phone && !tablet){
          // Keep the bow beside the final title line, with room around the letters.
          const besideYear=lastTitleLine && lastTitleLine.right+32+w<=b.right;
          x=besideYear?lastTitleLine.right+32:b.right+18;
          y=besideYear?lastTitleLine.top+8:b.top+24;
          // Include the subtitle and any other copy alongside the full bow height.
          const bowHeight=w*crops.productBow[4]/crops.productBow[3];
          const grid=content.querySelector('.product-grid');
          const walker=document.createTreeWalker(grid,NodeFilter.SHOW_TEXT);
          let text;
          while(text=walker.nextNode()){
            if(!text.textContent.trim() || ['SCRIPT','STYLE'].includes(text.parentElement.tagName))continue;
            const range=document.createRange();range.selectNodeContents(text);
            for(const r of range.getClientRects()){
              if(r.width && r.height && r.bottom-origin.top>y-12 && r.top-origin.top<y+bowHeight+12){
                x=Math.max(x,r.right-origin.left+24);
              }
            }
          }
          // Never let the viewport clamp push the bow back over the copy.
          if(x+w+6>origin.width){piece.hidden=true;continue;}
        }
      } else if (key==='storeExtraGift') {
        w=phone?58:tablet?70:86;
        // Anchor this gift to the charity card's quiet lower corner instead of the busy photo.
        const card=boxes.charity;
        if(!card){piece.hidden=true;continue;}
        x=card.right-w-(phone?16:24);
        y=card.bottom-w*.65;
      } else if (key==='charityBauble') {
        w=phone?52:70;
        const logo=boxes.charityImage;
        if(!logo){piece.hidden=true;continue;}
        x=logo.left+(phone?-8:12);
        y=logo.top+(phone?12:logo.height-w*.5);
      } else if (key==='productCandy') {
        w=phone?26:tablet?34:48;
        x=(boxes.productBow?.right || b.right)-w-16;
        y=b.top+6;
        if(!phone && !tablet){
          x=Math.min(b.right+44,(boxes.productBow?.right || origin.width)-w-12);
          y=b.top+(b.height-w*crops.productCandy[4]/crops.productCandy[3])/2;
        }
      }
      const crop=crops[key];
      const transform=getComputedStyle(piece).transform;
      const matrix=transform==='none'?null:new DOMMatrix(transform);
      const rotationInset=matrix?Math.max(0,(Math.abs(matrix.a)*w+Math.abs(matrix.c)*w*crop[4]/crop[3]-w)/2):0;
      x=Math.max(6+rotationInset,Math.min(origin.width-w-6-rotationInset,x));
      place(piece,x,y,w,w*crop[4]/crop[3]);
      artworkBoxes[key]={x,y,w,height:w*crop[4]/crop[3]};
    }
    const c=boxes.countdown,s=boxes.store,h=boxes.charity,f=boxes.faq;
    const panel=content.querySelector('.generic-countdown__panel');
    if(panel && c){
      const imageWidth=Math.max(c.width,phone?820:1024),scale=imageWidth/2172;
      const dimensions={width:imageWidth,height:724*scale,overlap:100*scale,'band-height':310*scale,crop:-350*scale,fade:80*scale};
      for(const [name,value]of Object.entries(dimensions))panel.style.setProperty('--adk-syrup-'+name,value+'px');
      panel.style.setProperty('--adk-syrup-x',phone?'65%':'50%');
      // Reserve the full drip depth in document flow, whichever section follows.
      panel.closest('.shopify-section').style.setProperty('--adk-syrup-depth',210*scale+'px');
    }

    // Place product sparkles in measured whitespace, never across copy or controls.
    const titleBox=boxes.productBow,priceBox=boxes.productCandy;
    const productStars=[...content.querySelectorAll('.adk-product-star')];
    productStars.forEach(node=>node.hidden=true);
    if(titleBox && priceBox){
      const region={left:titleBox.left+4,right:titleBox.right-4,top:titleBox.top-24,bottom:priceBox.bottom+40};
      const blocked=[];
      const record=r=>{if(r.width && r.height)blocked.push({left:r.left-origin.left-12,right:r.right-origin.left+12,top:r.top-origin.top-12,bottom:r.bottom-origin.top+12});};
      const grid=content.querySelector('.product-grid');
      const walker=document.createTreeWalker(grid,NodeFilter.SHOW_TEXT);let text;
      while(text=walker.nextNode()){
        if(!text.textContent.trim() || ['SCRIPT','STYLE'].includes(text.parentElement.tagName))continue;
        const range=document.createRange();range.selectNodeContents(text);
        for(const r of range.getClientRects())record(r);
      }
      grid.querySelectorAll('button,a,input,select,svg').forEach(node=>record(node.getBoundingClientRect()));
      for(const b of Object.values(artworkBoxes))blocked.push({left:b.x-10,right:b.x+b.w+10,top:b.y-10,bottom:b.y+b.height+10});
      // Reserve the open area beside the product details for a single bauble.
      const detailBauble=content.querySelector('[data-artwork="productDetailBauble"]');
      if(detailBauble){
        const angle=10*Math.PI/180;
        for(const width of (phone?[48,40]:[68,56])){
          const height=width*640/633,bw=Math.cos(angle)*width+Math.sin(angle)*height,bh=Math.sin(angle)*width+Math.cos(angle)*height;
          let best,score=Infinity;
          for(let y=region.top;y+bh<=Math.min(region.bottom,titleBox.bottom+160);y+=8){
            for(let x=region.left+(region.right-region.left)*.55;x+bw<=region.right;x+=8){
              if(blocked.some(b=>x<b.right&&x+bw>b.left&&y<b.bottom&&y+bh>b.top))continue;
              const distance=(x-(region.right-bw-8))**2+(y-(titleBox.bottom+24))**2;
              if(distance<score){score=distance;best={x,y};}
            }
          }
          if(best){
            detailBauble.hidden=false;place(detailBauble,best.x+(bw-width)/2,best.y+(bh-height)/2,width,height);
            blocked.push({left:best.x-20,right:best.x+bw+20,top:best.y-20,bottom:best.y+bh+20});
            break;
          }
        }
      }
      const cane=content.querySelector('[data-artwork="productCane"]');
      if(cane){
        const angle=12*Math.PI/180;
        for(const width of (phone?[36,32,28]:[56,48])){
          const height=width*1420/500,bw=Math.cos(angle)*width+Math.sin(angle)*height,bh=Math.sin(angle)*width+Math.cos(angle)*height;
          let best,score=Infinity;
          for(let y=region.top;y+bh<=region.bottom;y+=8){
            for(let x=region.left;x+bw<=region.right;x+=8){
              if(blocked.some(b=>x<b.right&&x+bw>b.left&&y<b.bottom&&y+bh>b.top))continue;
              const distance=(x-(region.right-bw-12))**2+(y-(priceBox.top-bh-24))**2;
              if(distance<score){score=distance;best={x,y};}
            }
          }
          if(best){
            cane.hidden=false;place(cane,best.x+(bw-width)/2,best.y+(bh-height)/2,width,height);
            blocked.push({left:best.x-14,right:best.x+bw+14,top:best.y-14,bottom:best.y+bh+14});
            break;
          }
        }
      }
      const targets=[[.66,.12],[.35,.30],[.84,.45],[.52,.62],[.77,.80],[.32,.94]];
      productStars.forEach((node,index)=>{
        const size=(phone?[26,16,22,14,20,12]:[40,24,34,20,30,18])[index];
        const [tx,ty]=targets[index];let best,score=Infinity;
        for(let y=region.top;y+size<=region.bottom;y+=12){
          for(let x=region.left;x+size<=region.right;x+=12){
            if(blocked.some(b=>x<b.right && x+size>b.left && y<b.bottom && y+size>b.top))continue;
            const distance=(x-(region.left+(region.right-region.left)*tx))**2+(y-(region.top+(region.bottom-region.top)*ty))**2;
            if(distance<score){score=distance;best={x,y};}
          }
        }
        if(!best)return;
        node.hidden=false;place(node,best.x,best.y,size,size);
        blocked.push({left:best.x-36,right:best.x+size+36,top:best.y-36,bottom:best.y+size+36});
      });
    }

    const gift=artworkBoxes.countdown;
    const ribbons = [
      c && gift && (phone?[c.right-171,c.top-40,160,-20]:[gift.x-26,gift.y-36,200,-34]),
      s && [s.left-(phone?116:204), s.top+s.height*(phone?.2:.24), phone?180:310, 55],
      s && [s.right-(phone?94:88), s.bottom-(phone?5:30), phone?210:330, 48],
      f && [f.left-(phone?132:185), f.bottom-(phone?120:170), phone?185:260, 30]
    ];
    content.querySelectorAll('.adk-ribbon').forEach(node=>{
      const spec=ribbons[Number(node.dataset.ribbon)];node.hidden=!spec;if(!spec)return;
      place(node,spec[0],spec[1],spec[2]);node.style.transform='rotate('+spec[3]+'deg)';
    });
    const stars=[
      c && [c.left+(phone?25:18),c.top-(phone?24:22),phone?19:30],
      c && [c.right-(phone?111:189),c.top-(phone?27:16),phone?24:38],
      s && [s.left+(phone?62:132),s.bottom+(phone?28:34),phone?24:36],
      s && [s.right-(phone?108:40),s.bottom+(phone?22:34),phone?12:16],
      h && [h.left+(phone?16:40),h.bottom+13,phone?12:17],
      f && [f.left+(phone?112:219),f.bottom+(phone?25:20),phone?19:25],
      s && [s.left-(phone?15:34),s.top+s.height*.43,phone?9:17],
      s && [s.right+(phone?4:22),s.top+s.height*.74,phone?10:19],
      s && [s.left+(phone?36:80),s.top-(phone?17:23),phone?8:13],
      h && [h.right+(phone?4:24),h.top+h.height*.49,phone?10:18],
      h && [h.left-(phone?15:38),h.top+h.height*.76,phone?9:15],
      h && [h.right-(phone?54:110),h.top-(phone?17:25),phone?12:20],
      f && [f.right+(phone?4:24),f.top+f.height*.36,phone?9:17],
      f && [f.left-(phone?15:36),f.top+f.height*.68,phone?10:19],
      f && [f.right-(phone?112:240),f.bottom+(phone?13:17),phone?8:12],
      c && [c.left+c.width*.38,c.top-(phone?49:56),phone?28:46],
      s && [s.left+s.width*.62,s.top-(phone?28:40),phone?22:34],
      s && [s.left+s.width*.43,s.bottom+(phone?25:26),phone?30:46],
      h && [h.left+h.width*.46,h.bottom+5,phone?22:30],
      f && [f.left+f.width*.70,f.bottom+28,phone?28:42],
      !phone && s && [s.left-60,s.top+s.height*.61,40],
      !phone && h && [h.right+18,h.top+h.height*.66,42],
      boxes.productSection && [boxes.productSection.left+boxes.productSection.width*.48,boxes.productSection.bottom-44,phone?26:40]
    ];
    content.querySelectorAll('.adk-composition-star').forEach((node,index)=>{
      const spec=stars[index];node.hidden=!spec;if(spec)place(node,...spec,spec[2]);
    });
  }
  function mount() {
    const content=document.querySelector('body[class*="adk-2026"] #content');
    const source=content?.querySelector('.adk-interlude[data-composition]');
    if(!content||!source)return;
    let field=content.querySelector('.adk-decor-field');
    if(!field){field=document.createElement('div');field.className='adk-decor-field';field.setAttribute('aria-hidden','true');content.append(field);}
    if(!field.querySelector('.adk-product-star')){
      for(let i=0;i<6;i++){const star=document.createElement('i');star.className='adk-product-star';field.append(star);}
    }
    for(const image of source.querySelectorAll('img[data-artwork]')) {
      const key=image.dataset.artwork,crop=crops[key];
      if(!crop)continue;
      field.querySelector('[data-artwork="'+key+'"]')?.remove();
      const piece=document.createElement('span');piece.className='adk-decoration adk-decoration--'+key;piece.dataset.artwork=key;
      Object.assign(image.style,{width:crop[0]/crop[3]*100+'%',left:-crop[1]/crop[3]*100+'%',top:-crop[2]/crop[4]*100+'%'});
      piece.append(image);field.append(piece);
    }
    let ribbonField=content.querySelector('.adk-ribbon-field');
    if(!ribbonField){
      ribbonField=document.createElement('div');ribbonField.className='adk-ribbon-field';ribbonField.setAttribute('aria-hidden','true');
      for(let i=0;i<4;i++){
        const ribbon=document.createElement('img');ribbon.className='adk-ribbon'+(i===0?' adk-ribbon--gold':'');ribbon.dataset.ribbon=i;ribbon.alt='';ribbon.src=i===0?source.dataset.goldRibbon:source.dataset.pinkRibbon;
        (i===0?content:ribbonField).append(ribbon);
      }
      for(let i=0;i<23;i++){const star=document.createElement('i');star.className='adk-composition-star';ribbonField.append(star);}
      content.append(ribbonField);
    }
    if(!observer)observer=new ResizeObserver(schedule);
    observer.disconnect();observer.observe(content);
    for(const selector of Object.values(selectors)){const target=content.querySelector(selector);if(target)observer.observe(target);}
    schedule();
  }
  window.adkDecorLayout={mount};
  window.addEventListener('resize',schedule);
  document.addEventListener('shopify:section:load',mount);
  document.addEventListener('shopify:section:reorder',mount);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount,{once:true});else mount();
  document.fonts?.ready.then(schedule);
})();
